// extracted by mini-css-extract-plugin
module.exports = {"footerLink":"FooterModalButton_footerLink__A6CQT","footerLinkWrapper":"FooterModalButton_footerLinkWrapper__DG_Rw","footerLinkText":"FooterModalButton_footerLinkText__T5ybq"};